import { render, staticRenderFns } from "./ReadTask.vue?vue&type=template&id=44734d4e&"
import script from "./ReadTask.vue?vue&type=script&lang=js&"
export * from "./ReadTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports